import { IGuide } from 'types/guide';

import * as actionTypes from './actionTypes';

export const fetchGuides = () => {
    return {
        type: actionTypes.FETCH_GUIDES,
    } as const;
};

export const setGuides = (payload: IGuide[]) => {
    return {
        type: actionTypes.SET_GUIDES,
        payload,
    } as const;
};

export const setLoadingState = (payload: boolean) => {
    return {
        type: actionTypes.SET_LOADING_STATE,
        payload,
    } as const;
};
